import { useState } from 'react'

import { NavTabs } from '@space-lib/components/navTabs'
import type { Context } from '@space-shell/common/services/notificationCenter'
import clsx from 'clsx'

import { CustomButtonTab, CustomNavTab, CustomNavTabItemLabel } from './styles'

export type NotificationTab = {
  id: Context
  label: string
  component: React.ReactNode
  hasUnreadNotification: boolean
}

export type NotificationNavTabProps = {
  onChangeTab?: () => void
  notificationsTab: NotificationTab[]
  defaultNotificationTabId?: Context
}

const NotificationNavTab = ({
  onChangeTab,
  notificationsTab,
  defaultNotificationTabId
}: NotificationNavTabProps) => {
  const initialTab = defaultNotificationTabId || notificationsTab[0].id
  const [activeTab, setActiveTab] = useState(initialTab)

  const activeTabData = notificationsTab.find((tab) => tab.id === activeTab)

  return (
    <>
      <CustomNavTab className='_px-2'>
        {notificationsTab.map((tab) => (
          <NavTabs.Item active={activeTab === tab.id} key={tab.id} className='_p-0 _px-2'>
            <CustomButtonTab
              className={clsx('_bg-transparent _border-0 _px-0 _pb-3 _pt-0 _m-0 _cursor-pointer', {
                isUnread: tab.hasUnreadNotification
              })}
              onClick={(e) => {
                e.stopPropagation()
                setActiveTab(tab.id)
                onChangeTab?.()
              }}
              role='tab'>
              {
                <CustomNavTabItemLabel
                  className='_mb-0 _text-2 _font-weight-bold _mx-2'
                  $isActive={activeTab === tab.id}>
                  {tab.label}
                </CustomNavTabItemLabel>
              }
            </CustomButtonTab>
          </NavTabs.Item>
        ))}
      </CustomNavTab>

      {activeTabData && activeTabData.component}
    </>
  )
}

export default NotificationNavTab
